// state.js

export default {
    isAuthenticated: false,
    user: null,
};
